import { deleteIcon, editIcon, emptyStateIcon } from "../../../assets/Icons/icons";
import { strings } from "../../../strings/strings";

const CountryAdminTable = ({ countryList, onEdit, onDelete }) => {
  return (
    <div className="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-gradient-to-r from-primary/10 via-primary/5 to-transparent border-b-2 border-primary/20">
              <th className="text-left px-8 py-5 text-xs font-bold text-secondary uppercase tracking-wider">
                {strings.countryName3}
              </th>
              <th className="text-left px-8 py-5 text-xs font-bold text-secondary uppercase tracking-wider">
                {strings.username}
              </th>
              <th className="text-left px-8 py-5 text-xs font-bold text-secondary uppercase tracking-wider">
                {strings.emailAddress}
              </th>
              <th className="text-left px-8 py-5 text-xs font-bold text-secondary uppercase tracking-wider">
                {strings.action2}
              </th>
            </tr>
          </thead>

          <tbody className="bg-white divide-y divide-gray-100">
            {countryList.length === 0 ? (
              <tr>
                <td colSpan="3" className="px-8 py-16 text-center">
                  <div className="flex flex-col items-center">
                    <div className="w-20 h-20 bg-gradient-to-br from-gray-100 to-gray-200 rounded-full flex items-center justify-center mx-auto mb-4 shadow-inner">
                      <img src={emptyStateIcon} alt="" className="w-10 h-10 opacity-60" />
                    </div>
                    <p className="text-lg font-semibold text-secondary mt-2">{strings.noadminaccountsfound}</p>
                    <p className="text-sm text-gray-500 mt-1">{strings.getstartedbyaddingfirstcountryadmin}</p>
                  </div>
                </td>
              </tr>
            ) : (
              countryList.map((item, index) => {
                return (
                  <tr
                    key={index}
                    className="hover:bg-gradient-to-r hover:from-primary/5 hover:to-transparent transition-all duration-200 border-b border-gray-100 group"
                  >
                    <td className="px-8 py-5">
                      <div className="flex items-center gap-3 w-max">
                        <span className="text-sm font-semibold text-secondary">
                          {item.countryName || "N/A"} <span className="ml-1">({item.country_code || "N/A"})</span>
                        </span>
                      </div>
                    </td>
                    <td className="px-8 py-5">
                      <span className="text-sm text-secondary font-medium">{item.username || "N/A"}</span>
                    </td>
                    <td className="px-8 py-5">
                      <span className="text-sm text-secondary font-medium">{item.email || "N/A"}</span>
                    </td>

                    <td className="px-8 py-5 flex gap-3">
                      <button
                        type="button"
                        onClick={() => onEdit(item)}
                        className="p-2 hover:bg-gray-100 bg-grey rounded-md transition-colors"
                        title={strings.edit}
                      >
                        <img src={editIcon} alt={strings.edit} className="w-3 h-3 min-w-[10px] min-h-[10px]" />
                      </button>
                      <button
                        type="button"
                        onClick={() => onDelete(item)}
                        className="p-2 hover:bg-red-100 bg-grey rounded-md transition-colors"
                        title={strings.delete}
                      >
                        <img src={deleteIcon} alt={strings.delete} className="w-4 h-4 min-w-[10px] min-h-[10px]" />
                      </button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CountryAdminTable;

